export default "/_next/static/images/8f/searchTablet-8f59ddfa948d7ea877456137ce90f658.jpg";